/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_PortalInputs */

const en_agent_portal = /** @type {(inputs: Agent_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent Portal`)
};

const es_agent_portal = /** @type {(inputs: Agent_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal del agente`)
};

const fr_agent_portal = /** @type {(inputs: Agent_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portail des agents`)
};

const de_agent_portal = /** @type {(inputs: Agent_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenten-Portal`)
};

const ja_agent_portal = /** @type {(inputs: Agent_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エージェントポータル`)
};

const zh_agent_portal = /** @type {(inputs: Agent_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理门户`)
};

const ar_agent_portal = /** @type {(inputs: Agent_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بوابة الوكيل`)
};

const id_agent_portal = /** @type {(inputs: Agent_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Agen`)
};

const it_agent_portal = /** @type {(inputs: Agent_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portale degli Agenti`)
};

const ru_agent_portal = /** @type {(inputs: Agent_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Портал агента`)
};

const pt_agent_portal = /** @type {(inputs: Agent_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal do Agente`)
};

const ko_agent_portal = /** @type {(inputs: Agent_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에이전트 포털`)
};

/**
* | output |
* | --- |
* | "Agent Portal" |
*
* @param {Agent_PortalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const agent_portal = /** @type {((inputs?: Agent_PortalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_PortalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_portal(inputs)
	if (locale === "es") return es_agent_portal(inputs)
	if (locale === "fr") return fr_agent_portal(inputs)
	if (locale === "de") return de_agent_portal(inputs)
	if (locale === "ja") return ja_agent_portal(inputs)
	if (locale === "zh") return zh_agent_portal(inputs)
	if (locale === "ar") return ar_agent_portal(inputs)
	if (locale === "id") return id_agent_portal(inputs)
	if (locale === "it") return it_agent_portal(inputs)
	if (locale === "ru") return ru_agent_portal(inputs)
	if (locale === "pt") return pt_agent_portal(inputs)
	return ko_agent_portal(inputs)
});